import { provideHttpClient, withFetch } from "@angular/common/http";
import { ApplicationConfig } from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withViewTransitions, withRouterConfig, withInMemoryScrolling } from "@angular/router";
import { AppRoutes } from "@app/app.routing";

export const appConfig: ApplicationConfig = {
  providers: [
    //basic
    provideHttpClient(withFetch()),
    provideAnimations(),

    //router
    provideRouter(AppRoutes,
      withViewTransitions(),
      withRouterConfig({ onSameUrlNavigation: "reload" }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: "enabled"
      }),
    ),
  ]
};
